const inPageNavInit = () => {
	const $navs = document.querySelectorAll('.block-in-page-nav');
	const $navButton = document.querySelectorAll('.block-in-page-nav__button');
	const $navLinks = document.querySelectorAll('.block-in-page-nav__link');

	$navButton.forEach((el) => {
		el.addEventListener('click', () => {
			if (el.closest('.block-in-page-nav').classList.contains('open')) {
				el.closest('.block-in-page-nav').classList.remove('open');
			} else {
				el.closest('.block-in-page-nav').classList.add('open');
			}
		});
	});

	$navLinks.forEach((el) => {
		el.addEventListener('click', () => {
			el.closest('.block-in-page-nav').classList.remove('open');
		});
	});

	document.addEventListener('click', (e) => {
		if (!e.target.closest('.block-in-page-nav')) {
			$navs.forEach((el) => {
				el.classList.remove('open');
			});
		}
	});
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		inPageNavInit();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
